<template>
  <div>
    <label for="activity">{{ $t('insights.ui.activity.label') }}</label>
    <select name="" class="form-control" id="activity" @change=emitConfig v-model="config.activity">
      <option :key="activity" v-for="activity in getActivities" :value="activity">{{ activity }}</option>
    </select>
  </div>
</template>

<script>
import generalMethods from "@/mixins/insights/generalMethods";
import {mapGetters} from "vuex";

export default {
  mixins: [generalMethods],
  name: "ActivitySelect",
  props: ['editing', 'currentConfig'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters('company', [
      'getActivities'
    ]),
  },
  created(){
    this.config = this.currentConfig
  }

}
</script>

<style scoped>

</style>